import type { MakeCall } from '../createMakeCall';
import { BillingInformation } from '../types/BillingInformation';

export interface APIUserMultiBillingData {
  billingInfos: BillingInformation[];
  count: number;
}

const getMultiBillingInformation = (makeCall: MakeCall) => () =>
  makeCall<APIUserMultiBillingData>('GET', `/api/v2/billing/billing-info`).then(
    res => ({
      ...res,
      data: {
        billingInformation: res.data.billingInfos,
        count: res.data.count,
      },
    }),
  );

export { getMultiBillingInformation };
